import { useData } from "@hooks/useData";
import {instantChartGetNameById} from "@core/api";

type Response = {
    name: string;
};

async function getInstantChartNameById(id: string): Promise<string> {
    if (!id) return '';
    try {
        const response: Response = await instantChartGetNameById(id);

        return `${response?.name}`;
    } catch (error) {
        console.error(`Error fetching instant chart name by ID: ${error}`);
        return '';
    }
}

export function useInstantChartNameById(id: string) {
    return useData('', getInstantChartNameById, id);
}